const getters = {
    loggedIn: state => state.auth.operator && state.auth.operator.id && !!state.auth.operator.user.roleName,
    user: state => state.auth.operator && state.auth.operator.user,
    operator: state => state.auth.operator,
    roleName: state => state.auth.operator && state.auth.operator.user && state.auth.operator.user.roleName,
    userBrandId: state => state.auth.operator && state.auth.operator.user && state.auth.operator.user.brandId,
    userEstablishmentId: state => state.auth.operator && state.auth.operator.user && state.auth.operator.user.establishmentId,
    userEstablishmentAddressId: state => state.auth.operator && state.auth.operator.user && state.auth.operator.user.establishmentAddressId,
    currentBranch: state => state.data.currentBranch
};

export default getters;
